import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Solar", href: "#services" },
  { label: "Battery", href: "#services" },
  { label: "Electrical", href: "#services" },
  { label: "EV Charging", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className="fixed top-0 left-0 w-full z-50 transition-all duration-300 bg-white border-b border-gray-100"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); handleNavClick("#home"); }}
          className="flex items-center cursor-pointer"
        >
          <img
            src="https://storage.readdy-site.link/project_files/02ee9be7-bc98-43d6-99e9-93e5834dd697/c425a6fa-6b0b-4d61-a5d6-5d19dc333234_wired-logo.jpg"
            alt="Wired Into The Future Logo"
            className="h-12 md:h-14 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="text-sm font-medium tracking-wide transition-colors cursor-pointer whitespace-nowrap text-gray-700 hover:text-amber-500"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:9258723408"
            className="text-sm font-medium whitespace-nowrap transition-colors text-gray-600 hover:text-amber-500"
          >
            <i className="ri-phone-line mr-1"></i>(925) 872-3408
          </a>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNavClick("#contact"); }}
            className="bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold px-5 py-2.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            Get a Quote
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden flex items-center justify-center w-9 h-9 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"} text-gray-900`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="text-gray-800 font-medium py-2 border-b border-gray-50 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:9258723408"
            className="flex items-center gap-2 text-amber-600 font-semibold py-2 cursor-pointer"
          >
            <i className="ri-phone-fill"></i> (925) 872-3408
          </a>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNavClick("#contact"); }}
            className="bg-amber-500 text-white text-center font-semibold py-3 rounded-md cursor-pointer"
          >
            Get a Quote
          </a>
        </div>
      )}
    </header>
  );
}
